<!-- Page Title -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content text-white">
                    <h2>Rapports</h2>
                    <ul class="text-gray-200">
                        <li><a routerLink="/" class="hover:underline">Accueil</a></li>
                        <li>Rapports</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Contenu -->
<section class="rapports-section ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Nos rapports d'activité</h2>
            <div class="bar"></div>
            <p>Retrouvez ici les rapports annuels d'activité de l'ASESA. Chaque document est disponible en téléchargement au format PDF.</p>
        </div>

        @if (rapportsParAnnee.length === 0) {
            <div class="no-rapports-box">
                <div class="no-rapports-icon">
                    <i class="fas fa-folder-open"></i>
                </div>
                <h3>Aucun rapport disponible pour le moment</h3>
                <p>Les rapports d'activité seront publiés ici dès qu'ils seront disponibles. Revenez bientôt !</p>
            </div>
        }

        @for (groupe of rapportsParAnnee; track groupe.annee) {
            <div class="annee-groupe mb-5">
                <h3 class="annee-titre">{{ groupe.annee }}</h3>
                <div class="row">
                    @for (rapport of groupe.rapports; track rapport.fichier) {
                        <div class="col-lg-4 col-md-6">
                            <div class="rapport-card">
                                <div class="rapport-icon">
                                    <i class="fas fa-file-pdf"></i>
                                </div>
                                <div class="rapport-info">
                                    <h4>{{ rapport.titre }}</h4>
                                    @if (rapport.description) {
                                        <p>{{ rapport.description }}</p>
                                    }
                                </div>
                                <a [href]="'assets/docs/' + rapport.fichier"
                                   download
                                   class="default-btn rapport-btn">
                                    Télécharger <span></span>
                                </a>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</section>

<!-- Abonnement newsletter -->
<app-subscribe></app-subscribe>
